import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";

@Directive({
  selector: "[StickyStretch]",
  host: { "(window:resize)": "resize()" },
})
export class StickyStretchDirective implements AfterViewInit, OnChanges {
  @Input() StickyStretch: any;
  initialized = false;
  private changes = new Subject();

  constructor(private el: ElementRef) {
    this.changes.pipe(debounceTime(30)).subscribe(() => {
      setTimeout(() => {
        this.setWidth();
      }, 0);
    });
  }
  ngOnChanges(): void {
    if (this.initialized) {
      this.changes.next();
    }
  }
  ngAfterViewInit(): void {
    this.initialized = true;
    this.setWidth();
  }
  resize() {
    this.changes.next();
  }
  setWidth() {
    // reset width
    this.el.nativeElement.style.width = null;
    // set width no new scroll width
    this.el.nativeElement.style.width = `${this.el.nativeElement.scrollWidth}px`;
  }
}
